import { storableError } from '../../util/errors';
import { apiBaseUrl } from '../../util/api';

// ================ Action types ================ //

export const FETCH_SOLD_ITEMS_REQUEST = 'app/ResalePage/FETCH_SOLD_ITEMS_REQUEST';
export const FETCH_SOLD_ITEMS_SUCCESS = 'app/ResalePage/FETCH_SOLD_ITEMS_SUCCESS';
export const FETCH_SOLD_ITEMS_ERROR = 'app/ResalePage/FETCH_SOLD_ITEMS_ERROR';

// ================ Reducer ================ //

const initialState = {
  soldItems: [],
  fetchSoldItemsInProgress: false,
  fetchSoldItemsResolved: false,
  fetchSoldItemsError: null,
};

export default function reducer(state = initialState, action = {}) {
  const { type, payload } = action;
  switch (type) {
    case FETCH_SOLD_ITEMS_REQUEST:
      return {
        ...state,
        fetchSoldItemsInProgress: true,
        fetchSoldItemsResolved: false,
        fetchSoldItemsError: null,
      };
    case FETCH_SOLD_ITEMS_SUCCESS:
      return {
        ...state,
        soldItems: payload.soldItems,
        fetchSoldItemsInProgress: false,
        fetchSoldItemsResolved: true,
      };
    case FETCH_SOLD_ITEMS_ERROR:
      return {
        ...state,
        fetchSoldItemsInProgress: false,
        fetchSoldItemsResolved: true,
        fetchSoldItemsError: payload,
      };
    default:
      return state;
  }
}

// ================ Action creators ================ //

export const fetchSoldItemsRequest = () => ({ type: FETCH_SOLD_ITEMS_REQUEST });
export const fetchSoldItemsSuccess = soldItems => ({
  type: FETCH_SOLD_ITEMS_SUCCESS,
  payload: { soldItems },
});
export const fetchSoldItemsError = e => ({
  type: FETCH_SOLD_ITEMS_ERROR,
  error: true,
  payload: e,
});

// ================ Thunks ================ //

export const fetchSoldItems = () => async (dispatch, getState, sdk) => {
  dispatch(fetchSoldItemsRequest());

  try {
    const response = await fetch(`${apiBaseUrl()}/api/sold-items`);

    if (!response.ok) {
      throw new Error(`Failed to fetch sold items: ${response.statusText}`);
    }

    const data = await response.json();
    const soldItems = data.data || [];

    dispatch(fetchSoldItemsSuccess(soldItems));
    return soldItems;
  } catch (e) {
    dispatch(fetchSoldItemsError(storableError(e)));
    throw e;
  }
};
